import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b619ddf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-bg-[#FCFCFC] tw-h-[119px] tw-w-[100%] tw-border tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]" }
const _hoisted_2 = { class: "tw-flex tw-h-full tw-justify-between" }
const _hoisted_3 = { class: "tw-flex align-items-end tw-p-5 tw-w-full" }
const _hoisted_4 = { class: "detail-info" }
const _hoisted_5 = { class: "tw-text-[#211F58] tw-text-[13px] tw-font-[500] tw-leading-[130%] tw-not-italic" }
const _hoisted_6 = { class: "tw-flex tw-justify-between tw-items-center tw-text-[15px] tw-font-[600] tw-leading-[130%] tw-not-italic" }
const _hoisted_7 = { class: "tw-flex tw-justify-between tw-items-center tw-font-[500] tw-my-[11px]" }
const _hoisted_8 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[25%] tw-h-[16px]"
}
const _hoisted_9 = {
  key: 1,
  class: "tw-font-[400]"
}
const _hoisted_10 = { class: "tw-pr-1 tw-text-[#B7B7B7]" }
const _hoisted_11 = { class: "tw-text-[#878787]" }
const _hoisted_12 = { class: "tw-flex tw-justify-between tw-items-center tw-font-[500]" }
const _hoisted_13 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[25%] tw-h-[16px]"
}
const _hoisted_14 = {
  key: 1,
  class: "tw-flex tw-items-center tw-gap-[15px]"
}
const _hoisted_15 = { class: "tw-font-[400]" }
const _hoisted_16 = { class: "tw-pr-1 tw-text-[#B7B7B7]" }
const _hoisted_17 = { class: "tw-text-[#878787]" }
const _hoisted_18 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[113px] tw-h-[117px] tw-border-l tw-border-[0] tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_19 = {
  key: 1,
  class: "tw-px-[5px] sm:tw-p-[20px] tw-border-l tw-border-solid tw-border-[#EFF0F1] tw-h-full tw-border-[0] tw-flex tw-justify-center tw-items-center tw-min-w-[80px]"
}

import {
  generateGradeScoreWithCompletedScore,
  TEXT_COLOR_WITH_GRADE_SCORE,
} from "@/services/assessment";
import { CHECKLISTSTATUS } from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";
import RadialProgressBar from "../prospect/prospectQuestions/componentTypes/radialProgressBar.vue";
import CyberHealthScoreChart from "../chart/cyberHealthScoreChart.vue";
import VendorAssessmentScoreChart from "../vendor/vendorAssessmentScoreChart.vue";

interface Evaluated {
  completed: number;
  total: number;
  percent: number;
}

interface Results {
  completed: number;
  total: number;
  percent: number;
}

interface Data {
  evaluated: Evaluated;
  results: Results;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentResultsCard',
  props: {
    data: {},
    isLoading: { type: Boolean },
    status: {},
    isVendorAssessment: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessments-results-card-title-1",
                )), 1),
            _createElementVNode("div", _hoisted_7, [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessments-results-passed-review-title-1",
                )) + " ", 1),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.data.evaluated.completed) + "/" + _toDisplayString(_ctx.data.evaluated.total), 1),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.data.evaluated.percent) + "%", 1)
                  ]))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessments-status-card-score-1",
                )) + " ", 1),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.data.results.completed) + "/" + _toDisplayString(_ctx.data.results.total), 1),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.data.results.percent) + "%", 1)
                    ])
                  ]))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18))
          : (_ctx.data.results.percent && _ctx.status !== _unref(CHECKLISTSTATUS).DONE)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(RadialProgressBar, {
                  class: "d-inline",
                  "total-steps": 100,
                  "completed-steps": _ctx.data.results.percent,
                  "is-hide-progress": true,
                  "outer-stroke-color": "#48A0FF"
                }, null, 8, ["completed-steps"])
              ]))
            : (
            _ctx.data.results.percent &&
            _ctx.status === _unref(CHECKLISTSTATUS).DONE &&
            _ctx.isVendorAssessment
          )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass([
            'tw-flex tw-items-center tw-justify-center tw-pt-[55px] tw-p-[20px] tw-bg-[#ffffff] tw-max-w-[113px] tw-max-h-[117px] tw-rounded-r-md tw-border-l tw-border-[0] tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]',
          ])
                }, [
                  _createVNode(VendorAssessmentScoreChart, {
                    "current-score": _ctx.data.results.percent / 100,
                    "pcnt-score": _ctx.data.results.percent / 100,
                    "note-color": '#62BB47',
                    "current-score-color": 
              Number(_ctx.data.results.percent / 100) === 0 ? '#F7553C' : '#01893D'
            ,
                    "total-score-color": 
              Number(_ctx.data.results.percent / 100) === 0 ? '#FEE5E2' : '#D9EDE2'
            ,
                    width: 155
                  }, null, 8, ["current-score", "pcnt-score", "current-score-color", "total-score-color"])
                ], 2))
              : (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: _normalizeClass([
            'tw-flex tw-items-center tw-justify-center tw-p-[20px] tw-bg-[#ffffff] tw-max-w-[113px] tw-max-h-[117px] tw-rounded-r-md tw-border-l tw-border-[0] tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]',
          ])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["tw-w-[113px] tw-h-[117px] tw-flex tw-items-center tw-justify-center tw-text-[30px] tw-font-[600]", `tw-text-[${
              _unref(TEXT_COLOR_WITH_GRADE_SCORE)[
                _unref(generateGradeScoreWithCompletedScore)(
                  Number(_ctx.data.results.percent),
                )
              ]
            }]`])
                  }, _toDisplayString(_unref(generateGradeScoreWithCompletedScore)(Number(_ctx.data.results.percent))), 3)
                ], 2))
      ])
    ])
  ]))
}
}

})